import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { iPaginationRequest, iPaginationResult } from 'src/app/helpers/Interfaces/pagination';
import {
  iWorkspaceRequest,
  iWorkspaceResult,
} from 'src/app/helpers/Interfaces/workspace';

import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  private readonly _getAll = `${environment.base_url}/api/Workspace/GetAll`;
  private readonly _getAllPaginated = `${environment.base_url}/api/Workspace/GetAllNew`;
  private readonly _getById = `${environment.base_url}/api/Workspace/GetById`;
  private readonly _add = `${environment.base_url}/api/Workspace/Add`;
  private readonly _update = `${environment.base_url}/api/Workspace/Update`;
  private readonly _remove = `${environment.base_url}/api/Workspace/Remove`;
  private readonly _permanentDelete = `${environment.base_url}/api/Workspace/PermanentDelete`;
  private readonly _toggle = `${environment.base_url}/api/Workspace/Toggle`;

  constructor(private _http: HttpClient) { }

  getById(id: string) {
    return this._http.get<iWorkspaceResult>(`${this._getById}?id=${id}`, {
      responseType: 'json',
    });
  }
  getAll() {
    return this._http.get<iWorkspaceResult[]>(this._getAll, {
      responseType: 'json',
    });
  }
  getAllWithRelationship(payload: iPaginationRequest) {
    return this._http.post<iPaginationResult<iWorkspaceResult>>(
      `${this._getAllPaginated}`,
      payload,
      {
        responseType: 'json',
      }
    );
  }
  add(payload: iWorkspaceRequest) {
    return this._http.post<iWorkspaceResult>(this._add, payload, {
      responseType: 'json',
    });
  }
  update(payload: iWorkspaceRequest) {
    return this._http.put<iWorkspaceResult>(this._update, payload, {
      responseType: 'json',
    });
  }
  remove(id: string) {
    return this._http.delete(`${this._remove}?id=${id}`, {
      responseType: 'json',
    });
  }
  permanentDelete(id: string) {
    return this._http.delete(`${this._permanentDelete}?Id=${id}`);
  }

  toggleStatus(workspaceId: string, isActive: boolean): Observable<any> {
    return this._http.put(`${this._toggle}?WorkspaceId=${workspaceId}&IsActive=${isActive}`, {});
  }
}
